import "./App.css";
import Hierarchy from "./components/hierarchy";

function App() {
  return <Hierarchy></Hierarchy>;
}

export default App;
